<template>
    <q-page padding>
        <!-- Modern Table Card -->
        <q-card class="presupuestos-table-card">
            <q-table ref="tableRef" dense :rows="rows" :columns="columns" row-key="name" v-model:pagination="pagination"
                :filter="filter" @request="onRequest"
                class="modern-presupuestos-table sticky-header-table sticky-last-column-table" flat>
                <template v-slot:top-left>
                    <div class="filters-section">
                        <PresupuestoFilter v-model="filtersData" v-model:vista="vistaTipo" @filters-apply="filtersApply"
                            @filter-remove="filterRemove" @filters-reset="filtersReset" />
                    </div>
                </template>
                <template v-slot:top-right>
                    <div class="toolbar-actions">
                        <PresupuestoColumnas v-model="columnasVisibles" :options="columnasOptions"
                            @change="tableRefreshVista" />
                        <q-select v-model="vistaTipo" :options="vistaTipoOptions" label="Vista"
                            class="vista-select q-mr-md" emit-value map-options @update:model-value="tableRefreshVista"
                            outlined dense hint="Seleccione vista">
                            <template v-slot:prepend>
                                <q-icon name="visibility" />
                            </template>
                        </q-select>
                        <q-input v-model="searchInput" placeholder="Buscar presupuestos..." class="search-input q-mr-md"
                            outlined dense @keyup.enter="filter = searchInput" hint="Presiona Enter para buscar">
                            <template v-slot:prepend>
                                <q-icon name="search" />
                            </template>
                            <template v-slot:append>
                                <q-icon v-if="searchInput" name="close" @click="searchInput = '', filter = ''" class="cursor-pointer" />
                            </template>
                        </q-input>
                        <q-btn unelevated color="primary" icon="save" label="Guardar Config" @click="setConfigValues"
                            class="save-config-btn">
                            <q-tooltip>Guardar configuración actual</q-tooltip>
                        </q-btn>
                    </div>
                </template>
                <template v-slot:body-cell-observaciones="props">
                    <q-td :props="props">
                        <div class="obs-cell">
                            <!-- <q-badge v-if="props.row.acopio" color="orange" icon="mdi-basket-unfill" label="Acopio" class="q-mr-sm">
                            <q-tooltip>Este presupuesto incluye acopio</q-tooltip>
                        </q-badge> -->
                            <q-badge v-if="props.row.total_cam" color="purple" icon="ac_unit" label="Cámara"
                                class="q-mr-sm">
                                <q-tooltip>Este presupuesto incluye cámaras frigoríficas</q-tooltip>
                            </q-badge>
                            <q-btn v-if="props.row?.observaciones?.length > 0" icon="mdi-alert-box" size="sm" round flat
                                color="red" @click="selectedPresupuesto = props.row; showObservacionesDialog = true">
                                <q-tooltip>Este presupuesto posee observaciones</q-tooltip>
                            </q-btn>
                            <span class="obs-text">{{ props.row.obs }}</span>
                        </div>
                    </q-td>
                </template>
                <template v-slot:body-cell-vendedor="props">
                    <q-td :props="props">
                        <div>{{ props.row.vendedor }}</div>
                        <div>{{ props.row.A3_XFZAVEN }}</div>
                    </q-td>
                </template>
                <template v-slot:body-cell-acciones="props">
                    <q-td :props="props">
                        <div class="action-buttons">
                            <q-btn v-if="isCamara(props.row)" :disable="disableIngenieria(props.row)"
                                color="deep-purple" round flat icon="engineering" size="sm"
                                @click="enviarIngenieria(props.row)" class="action-btn">
                                <q-tooltip>Enviar a Ingeniería</q-tooltip>
                            </q-btn>
                            <q-btn :disable="disablePrintPresup(props.row)" color="orange" round flat icon="print"
                                size="sm" @click="presupuestoPdfOpen(props.row)" class="action-btn">
                                <q-tooltip>Imprimir presupuesto</q-tooltip>
                            </q-btn>
                            <!-- <q-btn
                            v-if="!props.row.presupuesto_protheus_id"
                            color="pink"
                            :loading="exportLoading === props.row.id"
                            round
                            flat
                            icon="upload"
                            size="sm"
                            @click="presupuestoExport(props.row.id)"
                            class="action-btn"
                        >
                            <q-tooltip>Exportar a Protheus</q-tooltip>
                        </q-btn> -->
                            <q-btn :disable="disableViewPresup(props.row)" color="primary" round flat icon="edit"
                                size="sm" @click="edit(props.row)" class="action-btn">
                                <q-tooltip>Ver/Editar Presupuesto</q-tooltip>
                            </q-btn>
                        </div>
                    </q-td>
                </template>
                <template v-slot:body-cell-created="props">
                    <q-td :props="props">
                        <span class="row">{{ formatCreatedAt(props.row.created_at, "dd/MM/yyyy") }}</span>
                        <span>{{ formatCreatedAt(props.row.created_at, "HH:mm:ss") }}</span>
                    </q-td>
                </template>
                <template v-slot:body-cell-estado="props">
                    <q-td :props="props">
                        <div class="estado-cell">
                            <GltnSelectEstado v-model="props.row.estado" :presupuesto="props.row.id" :flow="true"
                                @update:modelValue="(val) => (props.row.estado = val)" @updated="tableRefreshVista" />
                        </div>
                    </q-td>
                </template>
                <template v-slot:body-cell-referencia="props">
                    <q-td :props="props">
                        <div class="referencia-cell">
                            <span class="referencia-text">{{ props.row.referencia }}</span>
                            <q-btn flat dense round size="sm" color="primary" icon="visibility"
                                @click="obraCrudDialog(props.row.obrasid, 'view')" class="view-obra-btn">
                                <q-tooltip>Ver detalles de la obra</q-tooltip>
                            </q-btn>
                        </div>
                        {{ props.row.A1_NOME }}
                    </q-td>
                </template>
                <template v-slot:body-cell-condpago="props">
                    <q-td :props="props">
                        <div class="condpago-cell">
                            <span class="condpago-text">
                                {{ props.row.E4_XDESCRI?.substring(0, 20) }}{{ props.row.E4_XDESCRI?.length > 20 ? '…' :
                                    '' }}
                                <q-tooltip v-if="props.row.E4_XDESCRI?.length > 20" max-width="300px">{{
                                    props.row.E4_XDESCRI }}</q-tooltip>
                            </span>
                        </div>
                    </q-td>
                </template>
                <template v-slot:body-cell-estado-liberacion="props">
                    <q-td :props="props">
                        <q-chip :color="estadoLiberacionColor(props.row.estado_liberacion)" text-color="white"
                            size="sm">
                            {{ props.row.estado_liberacion }} ({{ props.row.items_liberados }}/{{ props.row.total_items
                            }})
                        </q-chip>
                    </q-td>
                </template>

                <template v-slot:body-cell-presupuesto-protheus="props">
                    <q-td :props="props">
                        <div class="protheus-cell">
                            <q-chip :color="presupProtheusStauts(props.row.CJ_STATUS).color" text-color="white"
                                size="sm">
                                <q-avatar :color="presupProtheusStauts(props.row.CJ_STATUS).color" text-color="white"
                                    icon="fiber_manual_record" />
                                {{ props.row.CJ_NUM || "N/A" }}
                                <q-tooltip>{{ presupProtheusStauts(props.row.CJ_STATUS).label }}</q-tooltip>
                            </q-chip>
                        </div>
                    </q-td>
                </template>
            </q-table>
        </q-card>
        <ObraCrud v-model="obraCrudOpen" :oper="obraCrudOper" :id="obraId" @updated="tableRefreshVista" />
        <ObservacionesDialog v-model="showObservacionesDialog"
            :observaciones="selectedPresupuesto?.observaciones || []" />
        <q-inner-loading :showing="loading">
            <q-spinner-hourglass size="50px" color="primary" />
        </q-inner-loading>
    </q-page>
</template>

<script setup>
import GltnSelectEstado from "@/components/form/GltnSelectEstado.vue";
import ObraCrud from "@/components/obra/ObraCrud.vue";
import ObservacionesDialog from "@/components/ObservacionesDialog.vue";
import PresupuestoFilter from "@/pages/Presupuestos/components/PresupuestoFilter.vue";
import PresupuestoColumnas from "@/pages/Presupuestos/components/PresupuestoColumnas.vue";
import PresupuestoService from "@/services/PresupuestoService.js";
import numberFormat from "@/helpers/numberFormat";
import { format, isValid, parse } from "date-fns";
import { ref, onMounted } from "vue";
import { router } from "@inertiajs/vue3";
import { useDefaultDataStore } from "@/stores/useDefaultDataStore.js";
import { usePresupuestoHandler } from "@/composables/usePresupuestoHandler.js";
import { useAuthStore } from "@/stores/useAuthStore.js";
import { useQuasar } from "quasar";
import IngenieriaService from "../services/IngenieriaService";
import presupuestoProtheusStatus from "@/constants/presupuestoProtheusStatus.js";

const defaultData = useDefaultDataStore();
const { checkPermission } = useAuthStore();
const { exportar, exportLoading } = usePresupuestoHandler();

const obraCrudOpen = ref(false);
const obraCrudOper = ref("edit");
const obraId = ref(null);
const showObservacionesDialog = ref(false);
const selectedPresupuesto = ref(null);
const rows = ref([]);
const filter = ref("");
const searchInput = ref("");
const filters = ref([]);
const filtersData = ref({});
const tableRef = ref();
const loading = ref(false);
const $q = useQuasar();
const pagination = ref({
    sortBy: "id",
    descending: true,
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 10,
    cliente: true,
});
const vistaTipoOptions = [
    { label: "Presupuestos", value: "presupuestos" },
    { label: "Items", value: "items" },
];
const columnsPresupuesto = [
    { name: "id", label: "ID", field: "id", align: "left", sortable: true, visible: true },
    { name: "created", label: "Creado", field: "created_at", align: "left", sortable: true, visible: true },
    { name: "obraID", label: "Obra ID", align: "left", field: "obraID", sortable: true, visible: true },
    { name: "referencia", label: "Obra/Cliente", align: "left", field: "referencia", sortable: true, visible: true },
    { name: "vendedor", label: "Vendedor", align: "left", field: "vendedor", sortable: true, visible: true },
    { name: "user", label: "Usuario", align: "left", field: "user", sortable: true, visible: true },
    { name: "A3_XFZAVEN", label: "Fuerza Vta", align: "left", field: "A3_XFZAVEN", sortable: true, visible: true },
    { label: "Presup Padre", name: "presupuesto_padre", align: "left", field: "presupuesto_padre", visible: true },
    { label: "Pedido", name: "pedido_venta", align: "left", field: "pedido_venta", visible: true },
    { label: "Estado PV", name: "estado-liberacion", align: "left", field: "estado_liberacion", visible: true },
    { label: "Cond Pago", name: "condpago", align: "left", field: "E4_XDESCRI", visible: true },
    { name: "presupuesto-protheus", label: "Presup Protheus", align: "left", field: "CJ_NUM", sortable: true, },
    { label: "Estado", name: "estado", align: "center", field: "estado", visible: true },
    { label: "Total", name: "total", align: "right", field: "items_sum_total", format: (val) => numberFormat(val), visible: true },
    { label: "Obs", name: "observaciones", align: "left", field: "observaciones", visible: true },
    { label: "Acciones", name: "acciones", align: "center", visible: true },
];
const columnsItems = [
    { name: "id", label: "ID", field: "id", align: "left", sortable: true, visible: true },
    {
        name: "referencia",
        label: "Obra",
        align: "left",
        field: "referencia",
        sortable: true,
        visible: true

    },
    {
        name: "presupuesto_id",
        label: "Presup",
        align: "left",
        field: "presupuesto_id",
        sortable: true,
        visible: true

    },
    {
        name: "cliente",
        label: "Cliente",
        align: "left",
        field: "A1_NOME",
        sortable: true,
        visible: true
    },
    { label: "Grupo", name: "B1_WGRUP", align: "left", field: "B1_WGRUP", visible: true },
    { label: "Item", name: "B1_DESC", align: "left", field: "B1_DESC", visible: true },
    {
        name: "presupuesto-protheus",
        label: "Presup Protheus",
        align: "left",
        field: "CJ_NUM",
        sortable: true,
        visible: true

    },
    {
        name: "pedido",
        label: "Pedido",
        align: "left",
        field: "C6_NUM",
        sortable: true,
        visible: true
    },
    {
        label: "Total",
        name: "total",
        align: "right",
        field: "total",
        format: (val) => numberFormat(val),
        visible: true
    },
    {
        label: "Obs",
        name: "observaciones",
        align: "left",
        field: "observaciones",
        visible: true
    },
    {
        label: "Acciones",
        name: "acciones",
        align: "center",
        visible: true
    },
];
const columns = ref(columnsPresupuesto);
const columnasOptions = ref(columnsPresupuesto.map(col => ({ label: col.label, value: col.name })));
const columnasVisibles = ref(defaultData.getPresupuestoGridColumnas ?? columnasOptions.value.map(opt => opt.value));
const onRequest = async (props) => {
    const filter = props.filter;
    const { page, rowsPerPage, sortBy, descending } = props.pagination;
    loading.value = true;
    try {
        const { data, per_page, current_page, total } =
            await PresupuestoService.grid({
                page,
                rowsPerPage,
                sortBy,
                descending,
                filter,
                filters: filters.value,
                cliente: true,
                vistaTipo: vistaTipo.value,
            });
        rows.value = data;
        pagination.value.rowsPerPage = per_page;
        pagination.value.page = current_page;
        pagination.value.rowsNumber = total;
        pagination.value.sortBy = sortBy;
        pagination.value.descending = descending;
        if (vistaTipo.value === "presupuestos") {
            columns.value = columnasVisibles.value.length > 0
                ? columnsPresupuesto.filter(col => columnasVisibles.value.includes(col.name))
                : columnsPresupuesto;
        } else {
            columns.value = columnsItems;
        }
    } catch (error) {
        $q.notify({
            type: "negative",
            message: "Error al cargar los presupuestos",
        });
        console.error("Error loading presupuestos:", error);
    }
    loading.value = false;
};
onMounted(() => {
    // get initial data from server (1st page)
    tableRef.value.requestServerInteraction();
});
const tableRefreshVista = () => {
    tableRef.value.requestServerInteraction();
};
const filtersApply = (data) => {
    filters.value = data;
    tableRef.value.requestServerInteraction();
};
const filterRemove = (data) => {
    filters.value = data;
    tableRef.value.requestServerInteraction();
};
const filtersReset = (data) => {
    filters.value = data;
    tableRef.value.requestServerInteraction();
};
const edit = async (row) => {
    if (vistaTipo.value === "presupuestos") {
        router.visit(`/presupuestos/${row.id}`);
    } else {
        router.visit(`/presupuestos/${row.presupuesto_id}`);
    }
};
const presupuestoPdfOpen = async (row) => {
    let id = row.id;
    if (vistaTipo.value === 'items') {
        id = row.presupuesto_id;
    }

    const baseURL = import.meta.env.VITE_API_URL || "http://localhost:8000";
    window.open(baseURL + "/presupuestos/pdf/" + id, "_blank");
};

const presupuestoExport = async (id) => await exportar(id);

const disablePrintPresup = (row) => {
    return (
        !checkPermission("presupuesto.imprimir") && row.estado !== "BORRADOR"
    );
};
const disableViewPresup = (row) => !checkPermission("presupuesto.ver");
const formatCreatedAt = (value, dateFormat) => {
    if (!value) {
        return "—";
    }
    const date = parse(value, "dd-MM-yyyy HH:mm:ss", new Date());
    return isValid(date) ? format(date, dateFormat) : value;
};
const canExportPresup = (row) => {
    return row.estado !== "BORRADOR" && !row.presupuesto_protheus_id;
};

const canEditObra = (row) => checkPermission("obra.editar");

const isCamara = (row) => {
    return vistaTipo.value === "items" && row.B1_WGRUP === "WCNE";
};

const disableIngenieria = (row) => row.ingenieria_estado_id === '1';

const obraCrudDialog = async (id, oper) => {
    if (!checkPermission("obra.editar")) return;
    obraId.value = id;
    obraCrudOper.value = oper || "view";
    obraCrudOpen.value = true;
};

const vistaTipo = ref(defaultData.getPresupuestoGridVista);

const presupProtheusStauts = (status) => {
    return (
        presupuestoProtheusStatus[status] || {
            label: "Desconocido",
            color: "grey",
        }
    );
};

const estadoLiberacionColor = (estado) => {
    switch (estado) {
        case "TOTALMENTE LIBERADO":
            return "green";
        case "PARCIALMENTE LIBERADO":
            return "orange";
        case "NO LIBERADO":
            return "red";
        default:
            return "grey";
    }
};

const setConfigValues = () => {
    defaultData.setPresupuestoGrid({
        vista: vistaTipo.value,
        filters: filtersData.value,
        columnas: columnasVisibles.value,
    });
    $q.notify({
        type: "positive",
        message: "Configuración guardada",
    });
};

const enviarIngenieria = async (row) => {
    try {
        loading.value = true;
        await IngenieriaService.store({
            presupuesto_id: row.presupuesto_id,
            presupuesto_item_id: row.id,
            ingenieria_estado_id: 1,
        });
        tableRef.value.requestServerInteraction();
    } catch (error) {
        $q.notify({
            type: "negative",
            message: "Error al enviar el presupuesto a Ingeniería",
        });
        console.error("Error sending presupuesto to Ingeniería:", error);
    } finally {
        loading.value = false;
    }
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

// Modern Header
.presupuestos-header {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
    animation: fadeIn 0.5s ease-in-out;

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 24px;

        .title-section {
            display: flex;
            align-items: center;
            color: white;

            .q-icon {
                opacity: 0.95;
            }

            .text-h3 {
                font-weight: 600;
                margin-bottom: 4px;
            }
        }

        .q-badge {
            font-size: 14px;
            padding: 8px 16px;
            border-radius: 20px;
        }
    }
}

// Modern Table Card
.presupuestos-table-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .modern-presupuestos-table {
        :deep(.q-table__top) {
            padding: 16px;
            background: linear-gradient(to right, #f5f5f5, #fafafa);
            border-bottom: 2px solid #e0e0e0;
        }

        // :deep(.q-table thead tr),
        // :deep(.q-table tbody td) {
        //     height: 56px;
        // }

        :deep(.q-table thead th) {
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            background: #fafafa;
            color: #424242;
        }

        :deep(.q-table tbody tr) {
            transition: all 0.2s ease;

            &:hover {
                background: #f5f9ff;
                transform: translateX(2px);
            }
        }

        :deep(.q-table tbody td) {
            border-bottom: 1px solid #f0f0f0;
        }
    }
}

// Toolbar Actions
.toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    .vista-select {
        min-width: 150px;
    }

    .search-input {
        min-width: 280px;
    }

    .save-config-btn {
        white-space: nowrap;
    }
}

// Filters Section
.filters-section {
    display: flex;
    align-items: center;
    gap: 12px;
}

// Cell Styles
.obs-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    .obs-text {
        font-size: 13px;
        color: #424242;
    }
}

.action-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;

    .action-btn {
        transition: all 0.2s ease;

        &:hover {
            transform: scale(1.1);
        }
    }
}

.estado-cell {
    display: flex;
    align-items: center;
}

.referencia-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    .referencia-text {
        font-weight: 500;
        color: #424242;
    }

    .view-obra-btn {
        opacity: 0.7;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 1;
        }
    }
}

.protheus-cell {
    display: flex;
    align-items: center;

    .q-chip {
        font-weight: 500;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }
}

// Animations
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// Responsive
@media (max-width: 1024px) {
    .toolbar-actions {
        flex-wrap: wrap;

        .search-input {
            min-width: 200px;
        }
    }

    .presupuestos-header {
        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }
    }
}
</style>
